import base from './base'; // 导入接口域名列表
import axios from '@/utils/http'; // 导入http中创建的axios实例

const login = {
  // post提交
  login(username, password, code, uuid) {
    return axios.post(`${base.url}/login?username=` + username + "&password=" + password + "&code=" + code + "&uuid=" + uuid);
  },
  // 获取code
  getCode(param) {
    console.log(base.url,'base.url');
    console.log(base.path,'base.path');
    // return axios.get(`${base.url}${base.path}/verify/url?flag=` + param);
    return axios.get(`${base.url}${base.path}/verify/https/url?flag=` + param);
  },
  // 获取openId
  getOpenId(code) {
    return axios.get(`${base.url}${base.path}/verify/openid?code=` + code);
    // http://parkinglot.interface.easthuaxin.com/api/verify/openid?code=1
  },
  // 获取buyId
  getBuyId(code) {
    return axios.get(`${base.url}${base.path}/verify/xcx/buyid?code=` + code);
  }
  // getBuyId(code) {
  //   return axios.get(`${base.url}${base.path}/verify/buyid?code=` + code);
  // }
}

export default login;
